import classNames from "classnames";
import InputWrapper from "../../../../../components/Input/InputWrapper";

const LongText = ({ settings = {} }) => {
    return (
        <InputWrapper className="long">
            <span className={classNames({"required": settings.required})}>{settings.title}</span>
            <div/>
            {settings.description && <p>{settings.description}</p>}
        </InputWrapper>
    )
};

export default LongText;